import { styled, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';

// Shared styled components matching kanban project's CustomizableModal design
export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: 'white',
    padding: 0,
    maxWidth: { xs: '90vw', sm: '500px' }, // Matching kanban's maxWidth
    width: '100%',
    borderRadius: '4px',
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  borderRadius: '4px 4px 0px 0px',
  padding: '22px', // Matching kanban's exact padding
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '1.05rem',
  fontWeight: 600,
  position: 'relative', // For absolute positioning of close button
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  textAlign: { xs: 'center', sm: 'left' },
  padding: '20px 24px', // Matching kanban's exact padding
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: { xs: 'center', sm: 'flex-end' },
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: '16px 24px', // Matching kanban's exact padding
}));

// Styled buttons matching kanban's button styles
export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'unset',
  padding: '4px 35px', // Matching kanban's exact padding
  width: { xs: '100%', sm: 'auto' },
  transition: 'all 0.3s ease',
  '&:hover': {
    opacity: 0.8,
    transition: 'all 0.3s ease',
  },
}));

// Primary button (for actions like "Entendido")
export const PrimaryButton = styled(StyledButton)(({ theme }) => ({
  backgroundColor: '#6150AD',
  color: 'white',
  '&:hover': {
    backgroundColor: '#6150AD',
    opacity: 0.8,
  },
}));

// Outline button (for cancel actions)
export const OutlineButton = styled(StyledButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: '#6150AD',
  borderColor: '#6150AD',
  border: '1px solid #6150AD',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    opacity: 1,
  },
}));

// Danger button (for destructive actions like "Desconectar")
export const DangerButton = styled(StyledButton)(({ theme }) => ({
  backgroundColor: '#D32F2F',
  color: 'white',
  '&:hover': {
    backgroundColor: '#D32F2F',
    opacity: 0.8,
  },
}));

// Close button (X) in the top right corner of modal
export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '12px',
  right: '12px',
  boxShadow: 'none',
  padding: '5px',
  color: 'gray',
  fontSize: '12px',
  '&:focus': { 
    boxShadow: 'none' 
  },
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}));